<div mat-dialog-title>{{data.title}}</div>

<div mat-dialog-content>
  <p [innerHTML]="data.content"></p>
</div>

<div mat-dialog-actions align="end">
  <button matButton mat-dialog-close>Cancel</button>
  <button matButton="filled" (click)="confirm()">Confirm</button>
</div>
